/**
 * Video Duel Service — chama o endpoint stateless de comparação de VSLs.
 * Não persiste comparações; é uma agregação sob demanda das métricas
 * que já existem em tb_metrica/tb_conversions.
 */
import { api } from './api';
import type { VideoDuelComparisonResponse } from '@/components/video-duel/videoDuelData';

export interface CompareVideosPayload {
  videoIds: string[];
  inicio: string; // ISO date
  fim: string; // ISO date
}

export const videoDuelService = {
  async compare(payload: CompareVideosPayload): Promise<VideoDuelComparisonResponse> {
    const response = await api.post<{ data: VideoDuelComparisonResponse }>(
      '/video-duel/compare',
      payload,
    );
    return response.data;
  },
};
